import { TARGET_COLORS } from './dashboardTargetsUtils';

interface Props {
  onLaunchSystems: () => void;
  onLaunchBoats: () => void;
  onLaunchUpgrades: () => void;
  onLaunchUltimate: () => void;
  onLaunchCombined: () => void;
}

const buttonBaseClassName =
  'prose-paragraphBase px-4 py-2 border border-[#071011] text-[#071011] hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#071011]';

function DashboardConfettiControls({
  onLaunchSystems,
  onLaunchBoats,
  onLaunchUpgrades,
  onLaunchUltimate,
  onLaunchCombined,
}: Props) {
  return (
    <div className='mt-10 pt-6 border-t border-gray-10'>
      <div className='prose-heading5 mb-4'>Confetti controls</div>
      <div className='flex flex-wrap gap-2'>
        <button
          type='button'
          aria-label='Launch systems confetti'
          className={buttonBaseClassName}
          style={{ backgroundColor: TARGET_COLORS.systems }}
          onClick={onLaunchSystems}
        >
          Systems
        </button>
        <button
          type='button'
          aria-label='Launch boats confetti'
          className={buttonBaseClassName}
          style={{ backgroundColor: TARGET_COLORS.boats }}
          onClick={onLaunchBoats}
        >
          Boats
        </button>
        <button
          type='button'
          aria-label='Launch upgrades confetti'
          className={buttonBaseClassName}
          style={{ backgroundColor: TARGET_COLORS.upgrades }}
          onClick={onLaunchUpgrades}
        >
          Upgrades
        </button>
        <button
          type='button'
          aria-label='Launch ultimate confetti'
          className={buttonBaseClassName}
          style={{ backgroundColor: TARGET_COLORS.ultimate }}
          onClick={onLaunchUltimate}
        >
          Ultimate
        </button>
        <button
          type='button'
          aria-label='Launch combined confetti'
          className={buttonBaseClassName}
          style={{
            backgroundImage: `linear-gradient(90deg, ${TARGET_COLORS.systems}, ${TARGET_COLORS.boats}, ${TARGET_COLORS.upgrades}, ${TARGET_COLORS.ultimate})`,
          }}
          onClick={onLaunchCombined}
        >
          Combined
        </button>
      </div>
    </div>
  );
}

export default DashboardConfettiControls;
